import { css } from "styled-components";

import MapControlButtonStyle from "./MapControlButtonStyle";

const MapControlListStyle = (icon = null) => css`
  ${MapControlButtonStyle(icon)};
`;

export default MapControlListStyle;
